import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const LazyLogin = lazy(async () => await import('./login'));

export const LoginRouter: RouteObject = {
  path: 'login',
  element: <LazyLogin />
};
